<script>
import Tokensale from '@/views/launchpad/sale';
import Presale from '@/views/launchpad/presale';
import Simplesale from '@/views/launchpad/simplesale';
import { products } from '@/constants/launchpad';

export default {
  name: 'Upcoming',
  components: {
    Tokensale,
    Presale,
    Simplesale,
  },
  computed: {
    saleCampaign() {
      return this.$route.params.pid;
    },
    isINOsale() {
      return this.productParams.saleType === 'INO';
    },
    isSimpleSale() {
      return this.productParams.saleType === 'SMPL';
    },
    productParams() {
      return products[this.saleCampaign] || {};
    },
  },
};
</script>

<template>
  <div>
    <Presale v-if="isINOsale" />
    <Simplesale v-else-if="isSimpleSale" />
    <Tokensale v-else />
    <div class="main-wrap">
      <div class="text-right launchpad__link">
        <router-link :to="{ name: 'agreement' }">User Agreement</router-link>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
</style>
